__turbopack_context__.v({
  "arrow": "OffersTeaser-module__GY9lgW__arrow",
  "block": "OffersTeaser-module__GY9lgW__block",
  "blockLabel": "OffersTeaser-module__GY9lgW__blockLabel",
  "blockPromise": "OffersTeaser-module__GY9lgW__blockPromise",
  "card": "OffersTeaser-module__GY9lgW__card",
  "cards": "OffersTeaser-module__GY9lgW__cards",
  "count": "OffersTeaser-module__GY9lgW__count",
  "grid": "OffersTeaser-module__GY9lgW__grid",
  "gridNext": "OffersTeaser-module__GY9lgW__gridNext",
  "header": "OffersTeaser-module__GY9lgW__header",
  "tabPanel": "OffersTeaser-module__GY9lgW__tabPanel",
  "teaser": "OffersTeaser-module__GY9lgW__teaser",
  "transform": "OffersTeaser-module__GY9lgW__transform",
});
